// Always dark theme — immersive T&D design
export function useTheme() {
  return {
    isDark: true,
    bg: '#0a0a0a',
    card: 'rgba(255,255,255,0.05)',
    text: '#ffffff',
    textSecondary: 'rgba(255,255,255,0.55)',
    border: 'rgba(255,255,255,0.1)',
    navBg: 'rgba(10,10,10,0.85)',
    inputBg: 'rgba(255,255,255,0.06)',
    overlayBg: 'rgba(0,0,0,0.6)',
  };
}
